// extracted by mini-css-extract-plugin
export var eligibilityCardEligible = "_4a-0";
export var eligibilityCardNotEligible = "_4a-1";